module.exports = __webpack_public_path__ + "img/dashboard.5cf39377.svg";